module.exports = __webpack_public_path__ + "img/icon1.519dba63.svg";